// Located in Edit Code > Assets
document.addEventListener('DOMContentLoaded', function() {
  let userChoices = {
      goal: null,
      type: null,
      size: null,
  };

  const choices = document.querySelectorAll('[data-choices]');
  
  // Function to show the next layer and hide the current layer
  function showNextLayer(currentLayerId, nextLayerId) {
      // Hide the current layer
      document.getElementById(currentLayerId).style.display = 'none';
    
      // Show the next layer
      document.getElementById(nextLayerId).style.display = 'block';
  }

  // Function to display the final recommendation based on choices
  function displayRecommendation(goal = null, type = null, size = null) {
      const recommendations = document.querySelectorAll('[data-product-recommendation]');
  
      // Unhide 1st recommendation by default - improve cheaper 2m
      recommendations[0].style.display = "block";
  
      // Check user selection then hide default recommendation and show matched recommendation
      if (goal == 'improve' && type == 'cheaper' && size == '6m') {
          recommendations[0].style.display = "none";
          recommendations[1].style.display = "block";
      } else if (goal == 'improve' && type == 'convenient' && size == '2m') {
          recommendations[0].style.display = "none";
          recommendations[2].style.display = "block";
      } else if (goal == 'improve' && type == 'convenient' && size == '6m') {
          recommendations[0].style.display = "none";
          recommendations[3].style.display = "block";
      } else if (goal == 'maintain' && type == 'cheaper' && size == '2m') {
          recommendations[0].style.display = "none";
          recommendations[4].style.display = "block";
      } else if (goal == 'maintain' && type == 'cheaper' && size == '6m') {
          recommendations[0].style.display = "none";
          recommendations[5].style.display = "block";
      } else if (goal == 'maintain' && type == 'convenient' && size == '2m') {
          recommendations[0].style.display = "none";
          recommendations[6].style.display = "block";
      } else if (goal == 'maintain' && type == 'convenient' && size == '6m') {
          recommendations[0].style.display = "none";
          recommendations[7].style.display = "block";
      }
  }

  // On image click, store the user's choice for each layer
  choices.forEach(choice => {
      const layerItems = choice.querySelectorAll('.wheel-quiz__layer-item');
      let currentLayer = choice.getAttribute("id");
      let nextLayer = '';
      let lasChar = "";
  
      // Add click listener to images
      layerItems.forEach(layerItem => {
          layerItem.addEventListener("click", (e) => {
              if (layerItem.getAttribute("data-goal") !== null) {
                  userChoices.goal = layerItem.getAttribute("data-goal");
              }
  
              if (layerItem.getAttribute("data-type") !== null) {
                  userChoices.type = layerItem.getAttribute("data-type");
              }
  
              if (layerItem.getAttribute("data-size") !== null) {
                  userChoices.size = layerItem.getAttribute("data-size");
              }
  
              lastChar = currentLayer[currentLayer.length - 1];
              nextLayer = `layer${parseInt(lastChar) + 1}`;
  
              if (currentLayer == 'layer3') {
                  nextLayer = 'recommendation';
                  displayRecommendation(userChoices.goal, userChoices.type, userChoices.size);
              }
  
              showNextLayer(currentLayer, nextLayer);
          });
      });
  });
});